import { createAction, props } from '@ngrx/store';
import {
  ModalidadSeleccion,
  CreateModalidadSeleccionRequest,
  UpdateModalidadSeleccionRequest
} from '../models/modalidad-seleccion.interface';

// Load Modalidades Seleccion
export const loadModalidadesSeleccion = createAction(
  '[ModalidadSeleccion] Load Modalidades Seleccion'
);

export const loadModalidadesSeleccionSuccess = createAction(
  '[ModalidadSeleccion] Load Modalidades Seleccion Success',
  props<{ modalidadesSeleccion: ModalidadSeleccion[] }>()
);

export const loadModalidadesSeleccionFailure = createAction(
  '[ModalidadSeleccion] Load Modalidades Seleccion Failure',
  props<{ error: string }>()
);

// Create Modalidad Seleccion
export const createModalidadSeleccion = createAction(
  '[ModalidadSeleccion] Create Modalidad Seleccion',
  props<{ modalidadSeleccion: CreateModalidadSeleccionRequest }>()
);

export const createModalidadSeleccionSuccess = createAction(
  '[ModalidadSeleccion] Create Modalidad Seleccion Success',
  props<{ modalidadSeleccion: ModalidadSeleccion }>()
);

export const createModalidadSeleccionFailure = createAction(
  '[ModalidadSeleccion] Create Modalidad Seleccion Failure',
  props<{ error: string }>()
);

// Update Modalidad Seleccion
export const updateModalidadSeleccion = createAction(
  '[ModalidadSeleccion] Update Modalidad Seleccion',
  props<{ id: number; modalidadSeleccion: UpdateModalidadSeleccionRequest }>()
);

export const updateModalidadSeleccionSuccess = createAction(
  '[ModalidadSeleccion] Update Modalidad Seleccion Success',
  props<{ modalidadSeleccion: ModalidadSeleccion }>()
);

export const updateModalidadSeleccionFailure = createAction(
  '[ModalidadSeleccion] Update Modalidad Seleccion Failure',
  props<{ error: string }>()
);

// Delete Modalidad Seleccion
export const deleteModalidadSeleccion = createAction(
  '[ModalidadSeleccion] Delete Modalidad Seleccion',
  props<{ id: number }>()
);

export const deleteModalidadSeleccionSuccess = createAction(
  '[ModalidadSeleccion] Delete Modalidad Seleccion Success',
  props<{ id: number }>()
);

export const deleteModalidadSeleccionFailure = createAction(
  '[ModalidadSeleccion] Delete Modalidad Seleccion Failure',
  props<{ error: string }>()
);

// Toggle Modalidad Seleccion Status
export const toggleModalidadSeleccionStatus = createAction(
  '[ModalidadSeleccion] Toggle Modalidad Seleccion Status',
  props<{ id: number; isActive: boolean }>()
);

export const toggleModalidadSeleccionStatusSuccess = createAction(
  '[ModalidadSeleccion] Toggle Modalidad Seleccion Status Success',
  props<{ modalidadSeleccion: ModalidadSeleccion }>()
);

export const toggleModalidadSeleccionStatusFailure = createAction(
  '[ModalidadSeleccion] Toggle Modalidad Seleccion Status Failure',
  props<{ error: string }>()
);

// Search Modalidades Seleccion
export const searchModalidadesSeleccion = createAction(
  '[ModalidadSeleccion] Search Modalidades Seleccion',
  props<{ query: string }>()
);

export const searchModalidadesSeleccionSuccess = createAction(
  '[ModalidadSeleccion] Search Modalidades Seleccion Success',
  props<{ results: ModalidadSeleccion[] }>()
);

export const clearModalidadSeleccionSearch = createAction('[ModalidadSeleccion] Clear Search');

// Select Modalidad Seleccion
export const selectModalidadSeleccion = createAction(
  '[ModalidadSeleccion] Select Modalidad Seleccion',
  props<{ modalidadSeleccion: ModalidadSeleccion | null }>()
);

// Clear Error
export const clearModalidadSeleccionError = createAction('[ModalidadSeleccion] Clear Error');
